import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, defer, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SessionDeviceInfoService } from '../session-device-info.service';
import { TokenResponse, TwoFactorFinalizePayload } from 'core/models';

@Injectable({
    providedIn: 'root',
})
export class ApiTokenService extends ApiBaseService {
    public token = (
        email: string,
        password: string,
        terminateActiveSessions = false,
    ): Observable<TokenResponse> => {
        const params = {
            grant_type: 'password',
            username: email,
            password,
            ...(terminateActiveSessions ? { terminateActiveSessions: 'true' } : {}),
        };

        return defer(() => from(this.sessionDeviceInfoService.getLoginHeaders())).pipe(
            switchMap(headers =>
                this.post<TokenResponse>('', new HttpParams({ fromObject: params }), {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'None',
                    ...headers,
                }),
            ),
        );
    };

    public twoFactorToken(payload: TwoFactorFinalizePayload): Observable<TokenResponse> {
        const params = {
            grant_type: 'two_factor',
            pendingToken: payload.pendingToken,
            ...(payload.code ? { code: payload.code } : {}),
            ...(payload.terminatePreviousSession ? { terminateActiveSessions: 'true' } : {}),
        };

        return defer(() => from(this.sessionDeviceInfoService.getLoginHeaders())).pipe(
            switchMap(headers =>
                this.post<TokenResponse>('', new HttpParams({ fromObject: params }), {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'None',
                    ...headers,
                }),
            ),
        );
    }

    constructor(http: HttpClient, private sessionDeviceInfoService: SessionDeviceInfoService) {
        super(http, '/token', null);
    }
}
